export const ATTACHED_BRAND_URL = "https://customer-assets-lxgj4vgw.emergentagent.net/job_bfccfb5c-70e3-4d2f-8855-ddb0d15a8438/artifacts/sob4ev09_IMG-20260824-WA0025.jpg";

export const DEFAULT_SITE = {
  id: "fallback",
  brand_name: "Glow Cleaning Co.",
  brand_name_es: "Limpieza Glow Co.",
  phone: "(443) 967-9655",
  email: "glowcleaningbmore@gmail.com",
  service_region_en: "Baltimore City, Baltimore County, Annapolis, Howard County, Montgomery County, and all Maryland",
  service_region_es: "Baltimore City, Baltimore County, Annapolis, Howard County, Montgomery County y todo Maryland",
  hero_image_url: ATTACHED_BRAND_URL,
  logo_image_url: ATTACHED_BRAND_URL,
  hero_badge_en: "FAMILY-LED CLEANING FOR BALTIMORE & MARYLAND",
  hero_badge_es: "LIMPIEZA FAMILIAR PARA BALTIMORE Y TODO MARYLAND",
  headline_en: "Pristine living.\nPerfected locally.",
  headline_es: "Espacios impecables.\nPerfeccionados aquí.",
  subtitle_en: "Warm, detailed cleaning for the homes, businesses, and new beginnings that matter most.",
  subtitle_es: "Limpieza cálida y detallada para los hogares, negocios y nuevos comienzos que más importan.",
  primary_cta_en: "Talk to our team",
  primary_cta_es: "Habla con nuestro equipo",
  secondary_cta_en: "Call (443) 967-9655",
  secondary_cta_es: "Llama al (443) 967-9655",
  contact_heading_en: "Tell us what needs to glow.",
  contact_heading_es: "Cuéntanos qué necesita brillar.",
  contact_subtitle_en: "Share a few details and Kathy will get back to you with the right next step.",
  contact_subtitle_es: "Comparte algunos detalles y Kathy te responderá con el próximo paso indicado.",
  promo_en: "Residential and commercial cleaning, with a family touch.",
  promo_es: "Limpieza residencial y comercial, con un toque familiar.",
};

export const DEFAULT_GALLERY = [
  { slug: "marble-kitchen", image_url: "https://images.pexels.com/photos/7031879/pexels-photo-7031879.jpeg", title_en: "Deep kitchen detail", title_es: "Detalle profundo de cocina", alt_en: "Spotless modern kitchen cleaned by Glow Cleaning Co.", alt_es: "Cocina moderna impecable limpiada por Glow Cleaning Co." },
  { slug: "professional-cleaner", image_url: "https://images.pexels.com/photos/9462192/pexels-photo-9462192.jpeg", title_en: "A team you can trust", title_es: "Un equipo de confianza", alt_en: "Professional cleaner ready for a Maryland home", alt_es: "Profesional de limpieza lista para un hogar de Maryland" },
  { slug: "team-detail", image_url: "https://images.pexels.com/photos/9462679/pexels-photo-9462679.jpeg", title_en: "Quiet, careful teamwork", title_es: "Trabajo cuidadoso en equipo", alt_en: "Cleaning team coordinating supplies indoors", alt_es: "Equipo de limpieza coordinando suministros en interiores" },
  { slug: "bright-living-room", image_url: "https://images.unsplash.com/photo-1638885930125-85350348d266?crop=entropy&cs=srgb&fm=jpg&q=85", title_en: "Move-in ready", title_es: "Listo para mudarte", alt_en: "Bright living room prepared for a new beginning", alt_es: "Sala luminosa preparada para un nuevo comienzo" },
];

export const getText = (site, key, lang) => site[`${key}_${lang}`] || site[`${key}_en`];
